<template>
  <transition name="global-alert-slide">
    <div
      v-if="Alert && Alert.isShow"
      :class="['global-alert-bar', alertTypeClass]"
      role="alert"
    >
      <div class="global-alert-icon-wrap">
        <v-icon class="global-alert-icon">{{ alertIcon }}</v-icon>
      </div>
      <div class="global-alert-copy">
        <div class="global-alert-title">{{ alertTitle }}</div>
        <div class="global-alert-message">{{ Alert.message }}</div>
      </div>
      <v-spacer></v-spacer>
      <v-btn text small class="global-alert-close" title="Dismiss" @click="close">
        <v-icon small left>mdi-close</v-icon>
        Dismiss
      </v-btn>
    </div>
  </transition>
</template>
<script>
import { mapState } from 'vuex';
export default {
  name: 'Alert',
  data() {
    return {
      autoCloseTimer: null,
    };
  },
  computed: {
    ...mapState({
      Alert: (state) => state.ConfigModule.Alert,
    }),
    alertType() {
      return this.Alert?.type || "info";
    },
    alertTypeClass() {
      return `global-alert--${this.alertType}`;
    },
    alertIcon() {
      const icons = {
        success: "mdi-check-circle",
        error: "mdi-alert-circle-outline",
        warning: "mdi-alert",
        info: "mdi-information",
      };
      return icons[this.alertType] || icons.info;
    },
    alertTitle() {
      const titles = {
        success: "Success",
        error: "Action needed",
        warning: "Warning",
        info: "Notice",
      };
      return titles[this.alertType] || titles.info;
    },
  },
  watch: {
    $route() {
      this.close();
    },
    Alert: {
      deep: true,
      handler(alert) {
        if (alert?.isShow) {
          this.startAutoCloseTimer();
          this.addDismissListeners();
        } else {
          window.clearTimeout(this.autoCloseTimer);
          this.removeDismissListeners();
        }
      },
    },
  },
  mounted() {
    if (this.Alert?.isShow) {
      this.addDismissListeners();
    }
  },
  beforeDestroy() {
    window.clearTimeout(this.autoCloseTimer);
    this.removeDismissListeners();
  },
  methods: {
    close() {
      window.clearTimeout(this.autoCloseTimer);
      this.removeDismissListeners();
      if (!this.Alert?.isShow) return;
      this.$store.commit("ConfigModule/Alert", {
        ...this.Alert,
        isShow: false,
      });
    },
    addDismissListeners() {
      window.addEventListener("pointerdown", this.close);
      window.addEventListener("input", this.close);
    },
    removeDismissListeners() {
      window.removeEventListener("pointerdown", this.close);
      window.removeEventListener("input", this.close);
    },
    startAutoCloseTimer() {
      window.clearTimeout(this.autoCloseTimer);
      this.autoCloseTimer = window.setTimeout(this.close, 10000);
    },
  }
};
</script>
<style>
.global-alert-bar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  width: 100vw;
  min-height: 72px;
  padding: 14px 18px;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background: #e8f2ff;
  border-top: 1px solid #b8d7fb;
  color: #263238;
  box-shadow: 0 -6px 18px rgba(0, 0, 0, 0.16);
}

.global-alert-icon-wrap {
  flex: 0 0 auto;
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: rgba(0, 91, 168, 0.1);
  margin-top: 2px;
}

.global-alert-icon {
  color: #005ba8;
}

.global-alert-copy {
  min-width: 0;
  line-height: 1.35;
  padding-top: 1px;
}

.global-alert-title {
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 2px;
  color: #3d454d;
}

.global-alert-message {
  font-size: 14px;
  overflow-wrap: anywhere;
  color: #3d454d;
}

.global-alert-close {
  flex: 0 0 auto;
  color: #3d454d !important;
  font-weight: 700;
  letter-spacing: 0;
  margin-top: 4px;
}

.global-alert--success {
  background: #e3f4e9;
  border-top-color: #a8dbbb;
}

.global-alert--success .global-alert-icon-wrap {
  background: rgba(31, 122, 67, 0.12);
}

.global-alert--success .global-alert-icon {
  color: #1f7a43;
}

.global-alert--error {
  background: #f7dfdd;
  border-top-color: #e5aaa5;
}

.global-alert--error .global-alert-icon-wrap {
  background: rgba(180, 35, 24, 0.1);
}

.global-alert--error .global-alert-icon {
  color: #b42318;
}

.global-alert--warning {
  background: #fff3d6;
  border-top-color: #f1ca77;
}

.global-alert--warning .global-alert-icon-wrap {
  background: rgba(161, 92, 0, 0.12);
}

.global-alert--warning .global-alert-icon {
  color: #a15c00;
}

.global-alert-slide-enter-active,
.global-alert-slide-leave-active {
  transition: transform 0.18s ease, opacity 0.18s ease;
}

.global-alert-slide-enter,
.global-alert-slide-leave-to {
  opacity: 0;
  transform: translateY(100%);
}

@media (max-width: 480px) {
  .global-alert-bar {
    align-items: flex-start;
    flex-wrap: wrap;
    min-height: 0;
    padding: 12px;
  }

  .global-alert-close {
    margin-left: 46px;
  }
}
</style>
